import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

export default function Header() {
  useEffect(() => {
    AOS.init({ duration: 1000 }); // Customize the duration of the animations
  }, []);

  return (
    <div className="relative flex flex-col items-center justify-center w-full h-screen text-center px-4 overflow-hidden">
      {/* Background Video */}
      <div className="absolute inset-0 w-full h-full overflow-hidden">
        <video
          preload="auto"
          autoPlay
          loop
          muted // Add muted attribute to ensure autoplay works on most browsers
          className="object-cover w-full h-full opacity-60"
        >
          <source
            src="https://videos.pexels.com/video-files/7849764/7849764-uhd_2732_1440_25fps.mp4"
            type="video/mp4"
          />
          Your browser does not support the video tag.
        </video>
      </div>

      {/* Content Overlay */}
      <div
        className="relative z-10 p-4 bg-gradient-to-b from-black to-transparent rounded-lg shadow-2xl max-w-md mx-auto sm:max-w-lg md:max-w-xl lg:max-w-2xl transform transition-transform duration-300 hover:scale-105"
        data-aos="fade-up"
      >
        <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold text-white leading-tight shadow-md" data-aos="fade-down">
          Orgatro IT: Excellence in UX Design
        </h1>
        <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mt-2 shadow-md" data-aos="fade-down" data-aos-delay="200">
          Transform Your Digital Presence
        </h2>
        <p className="mt-4 text-sm sm:text-base md:text-lg lg:text-xl text-gray-300 shadow-md" data-aos="fade-up" data-aos-delay="400">
          At Orgatro IT, we are dedicated to delivering top-tier UX and web design solutions. Our expertise empowers businesses to elevate their digital experiences and achieve sustainable growth.
        </p>

        {/* Rating Section */}
        <div className="flex items-center mt-6 justify-center space-x-2">
          <img
            alt="Clutch logo"
            className="w-8 h-8 md:w-10 md:h-10 text-blue-500"
            src="https://storage.googleapis.com/a1aa/image/enlYc6EBGTzQOiQ741IyjQJT6ua8fwImeAPI9KkPamUW3TGnA.jpg"
          />
          <div className="text-left">
            <p className="text-lg md:text-xl font-bold text-white">
              5.0
              <span className="text-yellow-500 ml-1">
                {[...Array(5)].map((_, index) => (
                  <i key={index} className="fas fa-star"></i>
                ))}
              </span>
            </p>
            <p className="text-sm md:text-base text-gray-400">Based on 24 Clutch reviews</p>
          </div>
        </div>
      </div>
    </div>
  );
}
